import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const Slider = ({slider}) => {
 
  // Array of image URLs

const weburl=useSelector(state=>state.constants.weburl);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slider.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [slider.length]);

  return (
    <div className=" shadow-md rounded-lg bg-sky-200  overflow-hidden relative">
      {/* Slider Images */}
      <div
        className="flex transition-transform duration-500 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slider.map((image, index) => (
          <div
            key={index}
            className="w-full h-[200px] lg:h-[400px] md:h-[400px] xlg:h-[400px] flex-shrink-0 bg-contain "
            style={{ backgroundImage: `url(${weburl}${image.image})` }}
          ></div>
        ))}
      </div>

      {/* Navigation Dots */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {slider.map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full ${
              index === currentIndex ? "bg-white" : "bg-gray-400"
            }`}
            onClick={() => setCurrentIndex(index)}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default Slider;